import { parseDate } from "../../../com/dateUtil";

const url = '/device';

// 장비 관리 페이지 리스트 
export const getDeviceDataList = async (conn, pager, callback, reject, setLoading) => {  

  const {take, skip, sort, cid, userTerm, rgnCode, dongCode} = pager;
  const config = {
    params: {
      page: (take + skip) / take, 
      size: take,  
      sort,
      cid: cid, 
      userTerm: userTerm, 
      rgnCode: rgnCode, 
      dongCode: dongCode
    }
  }

  await conn 
    .get(url + "/list", config)
    .then(response => {      
      response.results.map(res => {
        switch (res.cmdStatus) {
          case 0: 
            res.cmdStatus = '-'           
            break;
          case 1:
            res.cmdStatus = '대기중'
            break;
          default:
            res.cmdStatus = '-'           
            break;                  
        }      
        
        switch (res.cmdType) {
          case 0:
            res.cmdType = '-';
            break;
          case 1:
            res.cmdType = '연결 상태 확인'
            break;
          case 2:
            res.cmdType = '응급신호 호출'
            break;
          case 3:
            res.cmdType = '센서테스트'
            break;
          case 4:
            res.cmdType = 'RESET'
            break;
          case 5:
            res.cmdType = '설정변경'
            break;
          case 6:
            res.cmdType = '펌웨어 업데이트'
            break;
          default:
            res.cmdType = '-'
            break;
        }
        
        if (res.gathDtm) res.gathDtm = res.gathDtm.substring(0, 10) + " " + res.gathDtm.substring(11, 19);        
        res.selected = false;
        
        return res;
      });


      callback(response);              
      setLoading(false);
    })
    .catch(error => {      
      console.log('error: ', error);
      reject(error);
    });
}


export const insertDeviceData = async (conn, dataItem) => {
  
  const {cid, imei} = dataItem;
 
  const params = {
    cid: cid,
    imei: imei,
  };

  const response = await conn.post(url + "/insert", params);

  return response;
};

export const setDeviceData = async (conn, data) => {
  
  const { deviceList, cmdType, emergencyType, cmdStatus, altDeviceCycle, altLidarDistance, fileName } = data;
  const params = {
    deviceList: deviceList,
    cmdType: cmdType,
    emergencyType: emergencyType,
    createDate: parseDate("yyyy-mm-dd hh:mm:ss", new Date()),
    cmdStatus: cmdStatus,
    altDeviceCycle: altDeviceCycle,
    altLidarDistance: altLidarDistance,
    firmwareName: fileName,
  };
  const response = await conn.post(url + "/update", params);

  return response;
};

export const deleteDeviceData = async (conn, data) => {

  const { cid } = data;

  const config = {
    headers: { "Content-Type": "application/json" },
    params: {
      cid: cid,
    }
  }

  const response = await conn.delete(url + "/delete", config);

  return response;
};

export const setDangerEvent = async (conn, data) => {
  
  const { cid } = data;
  const params = {
    cid: cid
  };
  const response = await conn.post(url + "/event/danger", params);

  return response;
};

